<div class="branded-asset-cover">
	<div class="middle">
		<div class="floating-entry">
			<div class="branded-asset-logo"></div>
			<table *ngIf="brand.poweredBy" class="powered-table">
				<tr>
					<td>Powered by</td>
					<td>
						<a href="https://www.gpms-vt.com/" class="branded-asset-poweredby"></a>
					</td>
				</tr>
			</table>
		</div>
		<div class="floating-entry">
			<div class="input-bounder">
				<form (ngSubmit)="Login()">
					<div [hidden]="showMfa">
						<div class="form-group">
							<label for="email">Email address</label>
							<input [(ngModel)]="email" name="email" type="email" id="email" class="form-control">
						</div>
						<div class="form-group">
							<label for="password">Password</label>
							<input [(ngModel)]="password" name="password" type="password" id="password" autocomplete="current-password" class="form-control">
						</div>
					</div>
					<div *ngIf="showMfa">
						<div class="form-group mb-5">
							<label for="mfa">MFA Code</label>
							<input [(ngModel)]="mfaCode" name="mfa_code" type="text" id="mfa" autocomplete="one-time-code" class="form-control">
						</div>
					</div>
					<div class="form-group">
						<button type="submit" class="btn btn-success">Log In</button>
						<button *ngIf="showMfa" type="button" class="btn btn-info ml-3" (click)="CancelMfa()">Cancel</button>
					</div>
				</form>
				<div *ngIf="errormessage" class="message-bad">{{errormessage}}</div>
				<div *ngIf="!showMfa" class="forgot-link">
					<a [routerLink]="['/forgot']">Forgot password?</a>
				</div>
			</div>
		</div>
	</div>
</div>